import { render, staticRenderFns } from "./DataSourceIcon.vue?vue&type=template&id=9023ada2&scoped=true"
import script from "./DataSourceIcon.vue?vue&type=script&lang=js"
export * from "./DataSourceIcon.vue?vue&type=script&lang=js"
import style0 from "./DataSourceIcon.vue?vue&type=style&index=0&id=9023ada2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9023ada2",
  null
  
)

export default component.exports